/**
 * Перечисления возвратов. Пока объявлены здесь, а не берутся из SDK: клиент
 * генерируется из OpenAPI работающего бэкенда, и модуль в него ещё не попал.
 * После первой перегенерации SDK эти списки заменяются на сгенерированные.
 */
export const OrderReturnStateEnum = {
  Expected: "expected",
  Announced: "announced",
  InProgress: "in_progress",
  Completed: "completed",
  Expired: "expired",
} as const;

export const OrderReturnOriginEnum = {
  Manual: "manual",
  Preauthorized: "preauthorized",
  Carrier: "carrier",
  ExternalWarehouse: "external_warehouse",
  Erp1Import: "erp1_import",
} as const;

export const DeadlineKindEnum = {
  Withdrawal: "withdrawal",
  FullWarranty: "full_warranty",
  Warranty: "warranty",
  Expired: "expired",
} as const;

export const ReturnDecisionEnum = {
  None: "none",
  Credit: "credit",
  Replacement: "replacement",
  Repair: "repair",
  Redeliver: "redeliver",
} as const;

export type OrderReturnState =
  (typeof OrderReturnStateEnum)[keyof typeof OrderReturnStateEnum];

/** Порядок полосы состояний: слева то, что в работе, справа терминальное. */
export const ORDER_RETURN_STATE_ORDER: OrderReturnState[] = [
  OrderReturnStateEnum.Announced,
  OrderReturnStateEnum.InProgress,
  OrderReturnStateEnum.Expected,
  OrderReturnStateEnum.Completed,
  OrderReturnStateEnum.Expired,
];

/**
 * Закрытый возврат: правкам не подлежит ни в одном экране. Состояния
 * перечислялись литералами в двух местах — карточка и приёмка расходились бы
 * при первом же новом состоянии.
 */
export const isTerminalReturnState = (state: string): boolean =>
  state === OrderReturnStateEnum.Completed ||
  state === OrderReturnStateEnum.Expired;

export const NoIntakeReasonEnum = {
  StaysWithCustomer: "stays_with_customer",
  ExternalWarehouse: "external_warehouse",
  NotFound: "not_found",
  Other: "other",
} as const;
